export const CryptoFundingHeader = () => {
  return (
    <div className="flex items-center justify-between">
      <div className="text-2xl font-medium">Crypto funding</div>
    </div>
  );
};
